/**
 * Interrupteur du design system Moovicar (classes définies dans mc-forms.css).
 * Utilisable partout à la place des `form-check form-switch` Bootstrap.
 */
function McSwitch({ id, label, checked, onChange }) {
  return (
    <label className="mc-switch" htmlFor={id}>
      <input type="checkbox" role="switch" id={id} checked={checked} onChange={onChange} />
      <span className="mc-switch-text">{label}</span>
      <span className="mc-switch-track" aria-hidden="true"></span>
    </label>
  );
}

export default McSwitch;
